<h1 mat-dialog-title>Edit products {{Error}}</h1>
<div mat-dialog-content>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" [formGroup]="FormularioConfirmar">
    <mat-form-field>
        <mat-label>LotNumber</mat-label>
        <input matInput  formControlName="LotNumber"/>
      </mat-form-field>
      <mat-form-field>
        <mat-label>StatedQuantity</mat-label>
        <input matInput formControlName="StatedQuantity"/>
      </mat-form-field>
      <mat-form-field>
        <mat-label>ActualQuantity</mat-label>
        <input matInput formControlName="ActualQuantity"/>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Discrepancy</mat-label>
        <input matInput formControlName="Discrepancy"/>
      </mat-form-field>
      <mat-form-field>
        <mat-label>AvailableQuantity</mat-label>
        <input matInput formControlName="AvailableQuantity"/>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Select location</mat-label>
        <mat-select formControlName="location">
          <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">{{
            item.Location
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="example-form-field">
        <mat-label>ExpirationDate</mat-label>
        <input matInput [matDatepicker]="ExpirationDate" formControlName="ExpirationDate">
        <mat-datepicker-toggle matSuffix [for]="ExpirationDate"></mat-datepicker-toggle>
        <mat-datepicker #ExpirationDate>
          <mat-datepicker-actions>
            <button mat-button matDatepickerCancel>Cancel</button>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
          </mat-datepicker-actions>
        </mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>SerialNumber</mat-label>
        <input matInput formControlName="SerialNumber"/>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Completed</mat-label>
        <mat-select disableRipple>
          <mat-option value="0">Not completed</mat-option>
          <mat-option value="1">Completed</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="example-form-field">
        <mat-label>CompletedDate</mat-label>
        <input matInput [matDatepicker]="CompletedDate" formControlName="CompletedDate">
        <mat-datepicker-toggle matSuffix [for]="CompletedDate"></mat-datepicker-toggle>
        <mat-datepicker #CompletedDate>
          <mat-datepicker-actions>
            <button mat-button matDatepickerCancel>Cancel</button>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
          </mat-datepicker-actions>
        </mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="Notes"></textarea>
      </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button  mat-raised-button class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  color="danger" (click)="onNoClick()">Cancel</button>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <button  mat-raised-button
  color="primary" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnConfirmar()">Confirm</button>
    </div>
  </div>
  
  
</div>
